import Vue from 'vue'
import Vuex from 'vuex'
import apiValue from './apiValue'
import setting from './setting'
import lesson from './lesson'
import pinchinData from './pinchinData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    apiValue,
    setting,
    lesson,
    pinchinData
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js